if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      constructor() {
        super();

        this.onButtonClick = this.onButtonClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('[data-cart-drawer-upsell-button]');
        this.errorElement = this.querySelector('.cart-drawer-upsell__error');

        if (this.button) {
          this.button.addEventListener('click', this.onButtonClick);
        }
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.onButtonClick);
        }
      }

      onButtonClick(event) {
        event.preventDefault();

        if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

        const variantId = this.button.dataset.variantId;
        if (!variantId) return;

        const cart = document.querySelector('cart-drawer');
        const sections = cart ? cart.getSectionsToRender().map((section) => section.id) : [];

        this.setLoading(true);
        this.handleErrorMessage();

        fetch(window.routes.cart_add_url, {
          ...fetchConfig('javascript'),
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
            sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description || window.cartStrings.error);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            cart.setActiveElement(document.activeElement);
            cart.renderContents(response);
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage(window.cartStrings.error);
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(isLoading) {
        const spinner = this.button.querySelector('.loading__spinner');

        this.button.classList.toggle('loading', isLoading);
        this.button.toggleAttribute('disabled', isLoading);

        if (isLoading) {
          this.button.setAttribute('aria-disabled', 'true');
        } else {
          this.button.removeAttribute('aria-disabled');
        }

        if (spinner) {
          spinner.classList.toggle('hidden', !isLoading);
        }
      }

      handleErrorMessage(message = '') {
        if (!this.errorElement) return;

        this.errorElement.textContent = message;
        this.errorElement.classList.toggle('is-visible', Boolean(message));
      }
    }
  );
}
